import ApiModel from 'models/api-model';
import { ANNOTATION_FONT_SIZE } from 'constants/feature/annotation-elements-constants';
export default class AnnotationFontSize extends ApiModel({
  data: {
    annotationFontSize: ANNOTATION_FONT_SIZE[3],
    fontSize: ANNOTATION_FONT_SIZE[3].value, // default font-size
  },
}) {
  get annotationFontSize() {
    return this.data.annotationFontSize;
  }
  get fontSize() {
    return this.data.fontSize;
  }
  setAnnotationFontSize({ fontSize }) {
    return this.merge({
      data: {
        ...this.data,
        annotationFontSize: fontSize,
        fontSize: fontSize.id,
      },
    });
  }
}
